import { Card, Slide } from "@material-ui/core";
import { SelectedVehiclesList } from "./SelectedVehiclesList";
import styles from "./SelectedVehiclesSlide.module.css";
import { useCallback, useState } from "react";

interface Props {}

export const SelectedVehiclesSlide = (props: Props) => {
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const handleSidebar = useCallback((isVisible: boolean) => {
    setSidebarVisible(isVisible);
  }, []);

  return (
    <>
      <Slide direction="left" in={true}>
        <Card
          className={`${
            sidebarVisible ? styles.sidebar : styles.sidebarClosed
          }`}
          style={{ backgroundColor: "rgba(0,0,0,0)" }}>
          <div className={styles.wrapper}>
            <SelectedVehiclesList handleSidebar={handleSidebar} />
          </div>
        </Card>
      </Slide>
    </>
  );
};
